<template>
  <!-- 产品 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <img
            class="arrow-left"
            src="@/assets/img/arrow-left.svg"
            alt=""
            @click="pushBack"
          />
          <span class="ml20">{{ productName }}</span>
          <v-button
            class="flr"
            :type="buttonType"
            name="showPublish"
            @click="showPublishProductModel()"
            >{{ this.status == 1 ? "撤销发布" : "发布产品" }}</v-button
          >
        </div>
      </div>
      <v-row class="tabs-demo__size">
        <v-col :span="22">
          <v-tabs v-model="activeName" size="S" name="tabs-s-card" type="card">
            <v-tab-pane label="产品信息" value="1">
              <ProductInfo
                :productName="productName"
                :productId="productId"
                :productKey="productKey"
                @changStatus="changStatus"
                ref="ProductInfo"
              ></ProductInfo>
            </v-tab-pane>
            <v-tab-pane label="Topic 类列表" value="2">
              <TopicList
                :productName="productName"
                :productId="productId"
                :productKey="productKey"
              ></TopicList>
            </v-tab-pane>
            <v-tab-pane label="功能定义" value="3">
              <DefineAbility
                :productName="productName"
                :productId="productId"
                :productKey="productKey"
              ></DefineAbility>
            </v-tab-pane>
          </v-tabs>
        </v-col>
      </v-row>
    </div>
    <publishModel
      :showInputDialog.sync="publishloading"
      @changStatus="changStatus"
      :status="this.status"
      :productName="productName"
      :productId="productId"
      ref="managrDetails"
    ></publishModel>
  </div>
</template>

<script>
import ProductInfo from "@/components/product/product-info.vue";
import TopicList from "@/components/product/topic-list.vue";
import DefineAbility from "@/components/product/define-ability.vue";
import publishModel from "@/components/product/publish.vue";

export default {
  components: { ProductInfo, TopicList, DefineAbility, publishModel },
  data() {
    return {
      activeName: "",
      productName: "",
      productId: "",
      publishloading: false,
      productKey: "",
      buttonType: "primary",
      status: 0
    };
  },
  created() {
    this.productName = this.$route.query.name;
    this.productId = this.$route.query.id;
    this.productKey = this.$route.query.key;
    this.activeName = this.$route.query.activeName;
    this.getData()
  },
  methods: {
    async getData () {
      const subData = {
        id: this.$route.query.id,
      };
      const res = await this.$getData("/td/td-iot-api/iot/product/v1", subData);
      if (res.code === 0) {
        this.status = res.data.publish_status
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    showPublishProductModel () {
      this.publishloading = !this.publishloading;
    },
    changStatus (value) {
      if (this.status !== value && this.activeName == 1) {
        this.$refs.ProductInfo.getData()
      }
      this.status = value;
    },
    pushBack () {
      this.$router.push({ name: "/deviceInfo-manage/product-list-info" });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
</style>
